import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { ac, roles } from "./permissions";

export const { signIn, signUp, useSession, admin } = createAuthClient({
  /** The base URL of the server (optional if you're using the same domain) */
  plugins: [
    adminClient({
      ac,
      roles,
    }),
  ],
  fetchOptions: {},
});
